import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { styled } from "@mui/material/styles";
import "./ReactToastify.css"

// custom styled container
// const StyledToastContainer = styled(ToastContainer)`
//   .Toastify__toast {
//     border-radius: 12px;
//     box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
//     padding: 12px 16px;
//     background: white;
//     font-family: "Inter", sans-serif;
//     min-height: auto;
//     width: 800px;  /* adjust as needed */
//     max-width: 90vw; /* make it responsive */
//     left: 20%
//   }

//   /* ✅ media queries */
//   @media (max-width: 1200px) {
//     .Toastify__toast {
//       width: 600px;
//       left: 15%;
//     }
//   }

//   @media (max-width: 900px) {
//     .Toastify__toast {
//       width: 500px;
//       left: 10%;
//     }
//   }

//   @media (max-width: 600px) {
//     .Toastify__toast {
//       width: 95%; /* full width on small screens */
//       left: 0;
//       margin: 0 auto; /* center align */
//     }
//   }

//   .Toastify__toast-body {
//     display: flex;
//     flex-direction: column;
//     gap: 4px;
//   }

//   .Toastify__toast-body div:first-of-type {
//     font-size: 14px;
//     font-weight: 500;
//     color: #111111;
//   }

//   .Toastify__toast-body div:last-of-type {
//     font-size: 12px;
//     font-weight: 400;
//     color: #11111199;
//   }

//   .Toastify__close-button {
//     // position: absolute;  
//     top: 50%;             
//     right: 12px;         
//     transform: translateY(-50%); 
//     color: #111111;
//     font-size: 14px;
//   }

//   .Toastify__toast-container--top-center {

//   }

// `;

const StyledToastContainer = styled(ToastContainer)`
  /* 🔥 Make container overlay */
  &.Toastify__toast-container {
    position: relative;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    pointer-events: none; /* optional */
    padding-bottom: 35px;
  }

  .Toastify__toast {
    pointer-events: all;
    border-radius: 12px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
    background: white;
    font-family: "Inter", sans-serif;
    min-height: auto;
    width: 100%;
    max-width: 90vw;
    position: relative;
  }
  
  .Toastify__close-button {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  margin: 0;
  padding: 0;
}

  /* Responsive */
  @media (max-width: 1200px) {
    .Toastify__toast {
      width: 100%;
    }
  }

  @media (max-width: 900px) {
    .Toastify__toast {
      width: 100%;
    }
  }

  @media (max-width: 600px) {
    .Toastify__toast {
      width: 95%;
      margin-bottom:"10px";
    }
  }

  .Toastify__toast-body {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;


export default StyledToastContainer;
